export default "__VITE_ASSET__CSDSpXvG__"